import React from 'react';
import { Chip, CHIP_VARIANTS, ICON_NAMES } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';
import { getConcernsCategoriesString } from '@utils/application';
import { ProfileInfoList } from '@components/Molecules/ProfileInfoList/index';
import { ProfileInfoHeader } from '@components/Molecules/ProfileInfoHeader/index';

const ProfileInfo = ({ modifier = '', firstName, concerns }) => {
  const { t } = useTranslation();

  return (
    <div className={`c-profile-info ${modifier}`}>
      <ProfileInfoHeader />

      {concerns ? (
        <div className="c-explanation c-profile-info__explanation--warning">
          <p className="c-explanatio__text">
            {t('candidate.sections.concerns.intro', { name: firstName })}
          </p>
          <div className="c-explanation__tags">
            <div className="c-explanation__tag">
              <Chip
                className="c-profile-info__chip c-profile-info__chip--relevant"
                leadingIcon={ICON_NAMES.WARNING_OUTLINE}
                variant={CHIP_VARIANTS.NEUTRAL}
              >
                {t('showcase.chip.interestedBut')}...
              </Chip>
            </div>

            <div className="c-explanation__tag">
              <Chip
                className="c-profile-info__chip"
                variant={CHIP_VARIANTS.NEUTRAL}
              >
                {getConcernsCategoriesString(concerns, t)}
              </Chip>
            </div>
          </div>
        </div>
      ) : null}

      <ProfileInfoList />
    </div>
  );
};

export default ProfileInfo;
